import { render, staticRenderFns } from "./FeatureGallery.vue?vue&type=template&id=aaf940be&"
import script from "./FeatureGallery.vue?vue&type=script&lang=js&"
export * from "./FeatureGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports